var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListen = function SvgListen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.593 14.5a.5.5 0 1 0 1 0zm-8.695 0a.5.5 0 0 0 1 0zm8.695-8.695V14.5h1V5.805zM3.898 14.5V5.805h-1V14.5zM7.745 1.958a3.847 3.847 0 0 1 3.848 3.847h1A4.847 4.847 0 0 0 7.745.958zm0-1a4.847 4.847 0 0 0-4.847 4.847h1a3.847 3.847 0 0 1 3.847-3.847z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.131 14.949a.5.5 0 0 0 0-1zm0-5.262a.5.5 0 1 0 0-1zm0 4.262A2.13 2.13 0 0 1 1 11.818H0a3.13 3.13 0 0 0 3.131 3.13zM1 11.818c0-1.177.954-2.131 2.131-2.131v-1A3.13 3.13 0 0 0 0 11.817zM12.092 8.686a.5.5 0 0 0 0 1zm0 5.263a.5.5 0 0 0 0 1zm0-4.263c1.178 0 2.132.954 2.132 2.132h1a3.13 3.13 0 0 0-3.132-3.132zm2.132 2.132a2.13 2.13 0 0 1-2.132 2.13v1a3.13 3.13 0 0 0 3.132-3.13z"
  })));
};
export default SvgListen;